import React, { Component } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
  Divider,
  Link as MuiLink
} from '@mui/material';
import {
  FitnessCenter as FitnessCenterIcon,
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  AccessTime as TimeIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();

    const quickLinks = [
      { label: 'Home', path: '/' },
      { label: 'About Us', path: '/about' },
      { label: 'Services', path: '/services' },
      { label: 'Pricing', path: '/pricing' }
    ];

    const services = [
      'Personal Training',
    ];

    const socialLinks = [
      { icon: InstagramIcon, url: 'https://instagram.com/varsityfitness', label: 'Instagram' },
      { icon: TwitterIcon, url: 'https://twitter.com/varsityfitness', label: 'Twitter' },
      { icon: YouTubeIcon, url: 'https://youtube.com/varsityfitness', label: 'YouTube' }
    ];

    return (
      <Box
        component="footer"
        sx={{
          backgroundColor: '#1C1C1C',
          color: 'white',
          pt: 6,
          pb: 3,
          mt: 'auto'
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Company Info */}
            <Grid item xs={12} md={4}>
              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <FitnessCenterIcon 
                    sx={{ 
                      color: 'primary.main', 
                      fontSize: 32, 
                      mr: 1 
                    }} 
                  />
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: 'primary.main'
                    }}
                  >
                    Varsity Fitness
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#D3D3D3',
                    lineHeight: 1.6,
                    mb: 3,
                    width: { xs: '100%', md: 500 }
                  }}
                >
                  Your fitness journey starts here. A home for fitness fans of all levels—a space rooted in pride, grit, and community, where every rep builds strength and belonging.
                </Typography>
                
                {/* Social Media Links */}
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {socialLinks.map((social) => {
                    const IconComponent = social.icon;
                    return (
                      <IconButton
                        key={social.label}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          color: '#D3D3D3',
                          '&:hover': {
                            color: 'secondary.main',
                            transform: 'translateY(-2px)'
                          },
                          transition: 'all 0.3s ease'
                        }}
                        aria-label={social.label}
                      >
                        <IconComponent />
                      </IconButton>
                    );
                  })}
                </Box>
              </Box>
            </Grid>

            {/* Services */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  color: 'secondary.main'
                }}
              >
                Our Services
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {services.map((service) => (
                  <Typography
                    key={service}
                    variant="body2"
                    sx={{
                      color: '#D3D3D3',
                      fontSize: '0.9rem'
                    }}
                  >
                    {service}
                  </Typography>
                ))}
              </Box>
            </Grid>

            {/* Contact Info */}
            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  color: 'secondary.main'
                }}
              >
                Contact Info
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <LocationIcon sx={{ color: 'primary.main', fontSize: 20, mt: 0.5 }} />
                  <Typography variant="body2" sx={{ color: '#D3D3D3', fontSize: '0.9rem' }}>
                    3430 Los Coyotes Diagonal<br />
                    Long Beach, CA 90808
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PhoneIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                  <MuiLink
                    href="tel:+15627141188"
                    sx={{
                      color: '#D3D3D3',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      '&:hover': { color: 'secondary.main' }
                    }}
                  >
                    (562) 714-1188
                  </MuiLink>
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <EmailIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                  <MuiLink
                    href="mailto:Varsityfitnesslb@outlook.com"
                    sx={{
                      color: '#D3D3D3',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      '&:hover': { color: 'secondary.main' }
                    }}
                  >
                    Varsityfitnesslb@outlook.com
                  </MuiLink>
                </Box>
              </Box>
            </Grid>
            {/* Hours */}
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  color: 'secondary.main'
                }}
              >
                Hours
              </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <TimeIcon sx={{ color: 'primary.main', fontSize: 20, mt: 0.5 }} />
                  <Box>
                    <Typography variant="body2" sx={{ color: '#D3D3D3', fontSize: '0.9rem' }}>
                      Mon–Thu: 5:00 AM - 9:00 PM<br />
                      Fri–Sat: 5:00 AM - 6:00 PM<br />
                      Sun: 8:00 AM - 5:00 PM
                    </Typography>
                  </Box>
                </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4, backgroundColor: '#4B4B4B' }} />

          {/* Bottom Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#D3D3D3',
                fontSize: '0.85rem'
              }}
            >
              © {currentYear} Varsity Fitness. All rights reserved. | Licensed & Insured
            </Typography>
            
            <Box sx={{ display: 'flex', gap: 3 }}>
              <MuiLink
                href="#"
                sx={{
                  color: '#D3D3D3',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  '&:hover': { color: 'secondary.main' }
                }}
              >
                Privacy Policy
              </MuiLink>
              <MuiLink
                href="#"
                sx={{
                  color: '#D3D3D3',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  '&:hover': { color: 'secondary.main' }
                }}
              >
                Terms of Service
              </MuiLink>
            </Box>
          </Box>
        </Container>
      </Box>
    );
  }
}

export default Footer;
